import React from 'react';
import PropTypes from 'prop-types';
import {Chart, Doughnut} from "react-chartjs-2";


const DoughnutStatusChart = ({ result }) => {

  if (!result || Object.keys(result).length === 0){
    return (
      <div/>
    );
  }
  
  Chart.pluginService.register({
    beforeDraw: function (chart) {
      if (chart.config.options.elements.center) {
        //Get ctx from string
        var ctx = chart.chart.ctx;
  
        //Get options from the center object in options
        var centerConfig = chart.config.options.elements.center;
        var fontStyle = centerConfig.fontStyle || 'Arial';
        var txt = centerConfig.text;
        var color = centerConfig.color || '#000';
        var sidePadding = centerConfig.sidePadding || 20;
        var sidePaddingCalculated = (sidePadding/100) * (chart.innerRadius * 2)
        //Start with a base font of 30px
        ctx.font = "30px " + fontStyle;
  
        //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
        var stringWidth = ctx.measureText(txt).width;
        var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
  
        // Find out how much the font can grow in width.
        var widthRatio = elementWidth / stringWidth;
        var newFontSize = Math.floor(25 * widthRatio);
        var elementHeight = (chart.innerRadius * 2);
  
        // Pick a new font size so it will not be larger than the height of label.
        var fontSizeToUse = Math.min(newFontSize, elementHeight);
  
        //Set font settings to draw it correctly.
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);

        var centY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
        var centY2 = (((chart.chartArea.top + chart.chartArea.bottom) / 2) / (1 * Math.PI));
       // console.debug("cent", centY, centY2);

        var centerY = centY + centY2;
        ctx.font = fontSizeToUse+"px " + fontStyle;
        ctx.fillStyle = color;
  
        //Draw text in center
        ctx.fillText(txt, centerX, centerY);
      }
    }
  });

  
  let chartOptions = {
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI,
    cutoutPercentage : 50,
    legend :{
      display:true,
      position:'right',
      fullWidth: false,
      labels :{
        fontSize: 8
      }
    },
    elements: { 
        center: {
        text: 'Staða',
        color: '#aaaaaa', //Default black
        fontStyle: 'Helvetica', //Default Arial
        sidePadding: 15 //Default 20 (as a percentage)
      }
    }
  }

  let datapoints = [
    result.currentSum.principal,
    result.currentSum.contractInterests,
      result.currentSum.bankCost,
      result.currentSum.penaltyInterests,
      result.currentSum.creditorCost,
      result.currentSum.accruedExpense,
      result.currentSum.outlaidExpense,
      result.currentSum.totalCostPenaltyInterests,
      result.currentSum.totalVat,
      0,
      0,
      0
  ]

  let datapoints2 = [
    0,
    0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      result.currentSum.discountsAndTerminations,
      result.currentSum.payments,
      result.remainderSum.total,
  ]

  let chartData = {
      datasets: [{
        data: datapoints,
        backgroundColor: [             
          '#b3b3ff',
          '#ffb3ec',
          '#66ff66',
          '#d2a679',
          '#cc3399',
          '#ffff00',
          '#4d4dff',
          '#ff3333',
          '#4dc3ff', 
          '#1aff66', 
          '#bbff33', 
          '#b3b3b3', 
        ],  
      },
      {
        data: datapoints2,
        backgroundColor: [             
          '#b3b3ff',
          '#ffb3ec',
          '#66ff66',
          '#d2a679',
          '#cc3399',
          '#ffff00',
          '#4d4dff',
          '#ff3333',
          '#4dc3ff', 
          '#1aff66', 
          '#bbff33', 
          '#b3b3b3', 
        ],  
      }],
      label: "Staða",        
      labels: 
        ['Höfuðstóll',
        'Samningsvextir',
        'Bankakostnaður',
        'Dráttavextir',
        'Kostnaður kröfuhafa',
        'Áfallinn kostnaður',
        'Útlagður kostnaður',
        'Vextir af kostnaði',
        'Virðisaukaskattur',
        'Afsláttur / niðurfelling',
        'Innborgun',
        'Eftirstöðvar']      
  };

  
  return (
    <Doughnut data={chartData} options={chartOptions} width={400} height={200} />
  );
};

DoughnutStatusChart.propTypes = {
    result: PropTypes.object,
};

export default DoughnutStatusChart;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Charts/DoughnutStatusChart.js